import { render, staticRenderFns } from "./serviceNas.vue?vue&type=template&id=f0b549f8&"
import script from "./serviceNas.vue?vue&type=script&lang=js&"
export * from "./serviceNas.vue?vue&type=script&lang=js&"
import style0 from "./serviceNas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports